// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-message[data-v-133d8b28] {\n  text-align: left !important;\n  line-height: 1.5 !important;\n  padding: 15px !important;\n}\n.custom-message .el-message__content[data-v-133d8b28] {\n  text-align: left !important;\n  line-height: 1.5 !important;\n}\n", ""]);
// Exports
module.exports = exports;
